import * as React from 'react';

import { NoWrapParagraph } from '../../components/cirium/NoWrapParagraph';
import { CiriumCard } from '../../components/cards/CiriumCard';

export interface TravelerOptOutCardProps {
  email: string;
}

const Description: React.FC<{ email: string }> = ({ email }) => (
  <NoWrapParagraph>
    This service will no longer send invitation emails to{' '}
    <NoWrapParagraph bold inline>
      {email}
    </NoWrapParagraph>
  </NoWrapParagraph>
);

export const TravelerOptOutCard: React.FC<TravelerOptOutCardProps> = ({ email }) => (
  <CiriumCard
    title="Trip Alert Opt-Out"
    description={<Description email={email} />}
  />
);